import { getAnalytics } from "@tm/insurance/analytics";
import { CheckButton } from "@tm/static";
import { ChangeEvent, useId } from "react";
import { useNetPriceContext } from "../contexts/NetPriceContext";
import {
  getPlainText,
  TextNodeType,
} from "../../FormattedText/FormattedText";
import FilterCriteriaLabel from "../FilterPlans/FilterCriteriaLabel";
import {
  ShowNetPriceCheckboxWrap,
  ShowNetPriceContainer,
  ShowNetPriceRow,
} from "./ShowNetPriceCard.style";

type ShowNetPriceCardProps = {
  text?: TextNodeType["text"];
  infoIcon?: string;
  popover?: {
    description?: {
      text?: { value?: string };
    };
  };
};

const ShowNetPriceCard = ({
  text,
  infoIcon,
  popover,
}: ShowNetPriceCardProps) => {
  const { showNetPrice, setShowNetPrice } = useNetPriceContext();
  const analytics = getAnalytics();
  const checkboxId = useId();

  const hasText = !!getPlainText({ text });
  const hasInfoIcon = !!infoIcon;

  if (!hasText && !hasInfoIcon) {
    return null;
  }

  const handleToggle = (event: ChangeEvent<HTMLInputElement>) => {
    const nextChecked = event.target.checked;
    analytics?.trackListingEvents({
      actionType: nextChecked
        ? "net_price_checked_clicked"
        : "net_price_unchecked_clicked",
    });
    setShowNetPrice(nextChecked);
  };

  return (
    <ShowNetPriceContainer>
      <ShowNetPriceRow>
        <ShowNetPriceCheckboxWrap>
          <CheckButton
            inputId={checkboxId}
            isChecked={showNetPrice}
            handleChange={handleToggle}
          >
            <FilterCriteriaLabel
              label={hasText ? { text } : undefined}
              infoIcon={infoIcon}
              popover={popover}
            />
          </CheckButton>
        </ShowNetPriceCheckboxWrap>
      </ShowNetPriceRow>
    </ShowNetPriceContainer>
  );
};

export default ShowNetPriceCard;
